import React from "react";
import { inject, observer } from "mobx-react";
import { Tooltip } from "antd";

import agent from "../../../../agent";

@inject("teamStore", "languageStore")
@observer
class SchoolName extends React.Component {
  state = {
    isLoading: true,
    name: ""
  };

  componentDidMount() {
    this.getSchoolName();
  }

  searchSchool() {
    const { school } = this.props.record;
    const lang = this.props.languageStore.lang;
    this.setState({
      isLoading: true
    });

    // 全匹配搜索当前用户名称对应的学校信息
    agent.SassPlatform.searchSchools({ name: school, mode: "1" })
      .then(res => {
        if (res && res.success && Array.isArray(res.data) && res.data.length > 0) {
          const schoolInfo = res.data[0];
          const { name, enName } = schoolInfo;
          this.setState({
            name: lang === "zh" ? name || enName : enName || name,
            isLoading: false
          });
        } else {
          this.setState({
            name: school,
            isLoading: false
          });
        }
      })
      .catch(err => {
        console.log(err);
        this.setState({
          name: school,
          isLoading: false
        });
      });
  }

  getSchoolName() {
    const schoolsInfo = this.props.teamStore.schoolsInfo;
    const record = this.props.record;
    const lang = this.props.languageStore.lang;
    const schoolItem = schoolsInfo.find(
      item => item.name === record.school || item.enName === record.school
    );

    if (schoolItem) {
      const { name, enName } = schoolItem;
      this.setState({
        name: lang === "zh" ? name || enName : enName || name,
        isLoading: false
      });
    } else {
      this.searchSchool();
    }
  }

  render() {
    const schoolsInfo = this.props.teamStore.schoolsInfo;
    if (!schoolsInfo || this.state.isLoading) return null;
    const name = this.state.name;

    return (
      <div className="school">
        <Tooltip title={name}>
          <span>{name}</span>
        </Tooltip>
      </div>
    );
  }
}

export default SchoolName;



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/teamInfoTabs/renderSchoolName.js